<template>
    <div class="sustainable-component manage-worktasks">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div v-html="$t('workorganisation_tab5_tool_tasks_text')"></div>

                    <v-select data-testid="distribution-position-select" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="jobPositionItems" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                    <v-btn data-testid="distribution-save-button" v-bind:disabled="disabled" class="bg-primary mb-3"
                           variant="text"
                           @click="saveJobPositionblocks">
                        {{$t('workorganisation_tab5_tool_tasks_add_task_button')}}
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <table data-testid="distribution-task-table" class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-4">Arbetsuppgift</th>
                                <th class="col-3">Utbildning</th>
                                <th class="col-3">Block</th>
                                <th class="col-2">Nr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in jobPositionTasks" :key="index" :data-testid="`distribution-task-row-${item.Id}`" :data-job-task-name="item.Name">
                                <td class="col-4">
                                    <span v-if="selected != item" v-html="item.Name"></span>
                                </td>
                                <td class="col-4">
                                    <span v-bind:disabled="disabled" v-if="selected != item" v-html="item.EducationAndRequirements"></span>
                                </td>
                                <td class="col-2">
                                    <div :data-testid="`distribution-task-block-select-${item.Id}`">
                                        <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" label="Block" :items="jobPositionBlocks" v-model="item.BlockId" item-title="Name" item-value="Id" density="compact"></v-select>
                                    </div>
                                </td>
                                <td class="col-2">
                                    {{item.BlockNumber}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);

    export default {

        name: 'manage-worktasks',
        emits: ['positionSelected', 'position-selected'],
        props: {
            model: Object,
            selectedJobPosition: [String, Number],
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            normalizeJobPositionId(value) {
                if (value === null || value === undefined || value === '') {
                    return null;
                }

                var asNumber = Number(value);
                return Number.isNaN(asNumber) ? value : asNumber;
            },
            syncJobPositionsFromModel() {
                this.internalModel = this.model;
            },
            setSelectedJobPositionFromProp(newVal) {
                var id = this.normalizeJobPositionId(newVal);
                if (id === null) {
                    return;
                }

                if (this.selectedPosition !== id) {
                    this.selectedPosition = id;
                }
            },
            ensureInitialSelection() {
                this.syncJobPositionsFromModel();
                this.setSelectedJobPositionFromProp(this.selectedJobPosition);

                if ((this.selectedPosition === null || this.selectedPosition === undefined || this.selectedPosition === '')
                    && this.jobPositionItems.length > 0) {
                    this.selectedPosition = this.jobPositionItems[0].JobPositionId;
                }
            },
            async getWorkTasks(id) {
                this.loading++;
                try {
                    this.jobPositionTasks = await WorkOrganisationService.getJobPositionWorkTasks(id);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getWorkBlocks(id) {
                this.loading++;
                try {
                    this.jobPositionBlocks = await WorkOrganisationService.getJobPositionblocks(id);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async saveJobPositionblocks() {
                this.loading++;
                try {
                    await WorkOrganisationService.saveJobPositionblocks(this.jobPositionTasks);
                    this.displaySnackBar("Sparad");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            
        },

        data() {
            return {
                rules: ValidationService.rules(),
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionBlocks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                selectedPosition: null,
                enableRegulation: false,
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        computed: {
            jobPositionItems() {
                var list = this.internalModel && Array.isArray(this.internalModel.JobPositions)
                    ? this.internalModel.JobPositions
                    : [];
                var selectedId = Number(this.selectedJobPosition || this.selectedPosition);
                if (Number.isNaN(selectedId) || selectedId <= 0) {
                    return list;
                }

                var selected = [];
                var rest = [];
                for (var i = 0; i < list.length; i++) {
                    var row = list[i];
                    var id = row && row.JobPositionId !== undefined ? row.JobPositionId : row && row.jobPositionId;
                    if (Number(id) === selectedId) {
                        selected.push(row);
                    }
                    else {
                        rest.push(row);
                    }
                }

                return selected.concat(rest);
            },
        },
        watch: {
            selectedPosition: function (newVal) {
                if (newVal === null || newVal === undefined || newVal === '') {
                    return;
                }
                this.getWorkTasks(newVal);
                this.getWorkBlocks(newVal);
                this.$emit('positionSelected', newVal);
                this.$emit('position-selected', newVal);
            },
            selectedJobPosition: function (newVal) {
                this.setSelectedJobPositionFromProp(newVal);
            },
            'model.JobPositions': function (newList, oldList) {
                if (newList !== oldList) {
                    this.syncJobPositionsFromModel();
                    this.setSelectedJobPositionFromProp(this.selectedJobPosition);
                }
            },
        },
        created() {
            this.ensureInitialSelection();
        },
        mounted() {
            this.ensureInitialSelection();
        },
        setup() {
            return { form }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  
</style>
